import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from '@tcc/i18n';
import styles from '../table.css';
import SoilSsurgoZoneRows from './SoilSsurgoZoneRows';
import Card from '../cardAndPreview/Card';
import { BASE_LAYERS } from '../../../constants/mapLayerIds';

function SoilSsurgoCard(props) {
  const { activeLayer, zones } = props;

  const soilSurgoLayerName =
    activeLayer === BASE_LAYERS.SOIL_TYPE ? 'SOIL_TYPE' : 'DRAINAGE';
  const soilSurgoLayer = BASE_LAYERS[soilSurgoLayerName];

  return (
    <Card
      errorMessage={zones && !zones.length ? getMessage('noDataError') : ''}
      isLoading={!zones}
      testId={soilSurgoLayer}
      title={getMessage(`layer.${soilSurgoLayer}`)}
    >
      <table className={styles.table}>
        <thead>
          <tr>
            <th data-test-id="soil-ssurgo-label-area">
              {getMessage('card.soilssurgo.area')}
            </th>
            {activeLayer && (
              <th data-test-id={`soil-ssurgo-label-${activeLayer}`}>
                {getMessage(`card.soilssurgo.${activeLayer}`)}
              </th>
            )}
          </tr>
        </thead>
        <SoilSsurgoZoneRows {...props} />
      </table>
    </Card>
  );
}

SoilSsurgoCard.propTypes = {
  activeLayer: PropTypes.string,
  activeZoneIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  zones: PropTypes.array,
};

export default SoilSsurgoCard;
